'use client'

import s from "../page.module.scss";
import {useEffect, useState} from "react";
import {getAllProjects} from "@/app/[locale]/common/utils/functions/getAllProjects/getAllProjects";
import {
    extractDescriptionProjectFromJSON
} from "@/app/[locale]/common/utils/functions/extractDescriptionProjectFromJSON/extractDescriptionProjectFromJSON";
import {ProjectCard} from "@/app/[locale]/common/components/ProjectCard/ProjectCard";
import {
    getStateFromLocalStorage
} from "@/app/[locale]/common/utils/functions/getStateFromLocalStorage/getStateFromLocalStorage";
import {Pagination} from "@/app/[locale]/common/components/Pagination/Pagination";
import {TAllProjectItem, TProjectsClientComponentProps} from "@/app/[locale]/projects/types";
import {Preloader} from "@/app/[locale]/common/components/Preloader/Preloader";
import {Empty} from "@/app/[locale]/common/components/Empty/Empty";

export const ProjectsClientComponent = ({ currentPage }: TProjectsClientComponentProps) => {
    const [ data, setData ] = useState<TAllProjectItem[] | null>(null);
    const [ rowTotalCount, setRowTotalCount ] = useState<number>(1);
    const [ currentPageNumber, setCurrentPageNumber ] = useState<null | number>(null);

    useEffect(() => {
        const fetchData = async () => {
            if (currentPage === 1) {
                const storedProjects = getStateFromLocalStorage('projects');
                const storedRowTotalCount = getStateFromLocalStorage('projectsRowTotalCount');

                if (!storedProjects || !storedRowTotalCount) {
                    await getAllProjects(currentPage, setData, setRowTotalCount);
                    setCurrentPageNumber(currentPage);
                    return;
                }

                if (storedRowTotalCount) {
                    setRowTotalCount(storedRowTotalCount);
                }

                if (storedProjects) {
                    const projects: TAllProjectItem[] = extractDescriptionProjectFromJSON(storedProjects);
                    setData(projects);
                    setCurrentPageNumber(currentPage);
                    return;
                }
            }
            await getAllProjects(currentPage, setData, setRowTotalCount);
            setCurrentPageNumber(currentPage);
        };

        fetchData();
    }, [currentPage]);

    if (!data || currentPageNumber !== currentPage) {
        return <Preloader />;
    }

    if (!data.length) {
        return <Empty />;
    }

    return (
        <div>
            <div className={s.projects_cardsContainer}>
                {
                    data.map((item: TAllProjectItem) => (
                        <ProjectCard
                            key={item.id}
                            id={item.id}
                            title={item.title}
                            shortText={item.shortText}
                            img={item.img}
                        />
                    ))
                }
            </div>
            <div className={s.projects_pagination}>
                <Pagination
                    type={'projects'}
                    currentPage={currentPage}
                    numberPages={Math.ceil(rowTotalCount / 3)}
                />
            </div>
        </div>
    );
};
